import { createFileRoute } from "@tanstack/react-router";
import THREEViewer from "gfx/THREEViewer";
import getPageTitle from "lib/utils/getPageTitle";
import type { ReactNode } from "react";
import { useEffect, useRef } from "react";
import { Helmet as Head } from "react-helmet-async";
import withAuthentication from "../../../components/withAuthentication";

const WebGLInfoPage = (): ReactNode => {
  const viewerContainerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    new THREEViewer({
      container: viewerContainerRef.current,
      options: {
        forceEnableIfGpuUnavailable: true,
        animate: true,
      },
    });
  }, []);

  return (
    <>
      <Head>
        <title>{getPageTitle("Debug - THREEViewer initialization auto test")}</title>
      </Head>
      <div ref={viewerContainerRef} style={{ width: "100%", height: "100%", overflow: "hidden" }}></div>
    </>
  );
};

export const Route = createFileRoute("/debug/gfx-test/threeviewer-init")({
  component: withAuthentication(WebGLInfoPage, { superAdmin: true }),
});
